module.exports = "/_next/static/images/popup-bg-history-7fa6c242.png";